<template>
  <div class="contract-index">
    <div class="con-header">我的合同</div>
    <!-- v-loading="loading"  v-if="conList.length"-->
    <div class="con-list-wrap">
      <el-tabs>
        <el-tab-pane v-for="conData in conDataList" :label="conData.templateMode" :key="conData.templateModeCode">
          <ul class="ul-cls con-list clearfix">
            <div v-for="con in conData.items" :key="con.id">
              <li v-if="con.isDefault == '1'">
                <div class="flex justify_between">
                  <p class="f16 fb"><span class="red">[默认]</span>{{ con.name }}</p>
                </div>
                <div class="box10"></div>
                <p v-if="con.nameMap.categoryOptionsList && con.nameMap.categoryOptionsList.split(',').length > 1">
                  <span class="fb">应用商品：</span>
                  {{ con.nameMap.categoryOptionsList.split(",")[0] }}{{ "、" + con.nameMap.categoryOptionsList.split(",")[1] + "..." }} 等品类下所有商品
                </p>
                <p v-else-if="con.nameMap.categoryOptionsList && con.nameMap.categoryOptionsList.split(',').length > 0">
                  <span class="fb">应用商品：</span>
                  {{ con.nameMap.categoryOptionsList.split(",")[0] + "..." }} 等品类下所有商品
                </p>
                <p v-else><span class="fb">应用商品：</span> 暂无</p>
                <p><span class="fb">应用客户：</span> 所有无专属合同模板客户</p>
                <p>
                  <span class="fb">自动签署：</span>
                  <el-switch v-model="con.isAutoSign" :active-value="1" :inactive-value="0" @change="editAutoSign(con)"></el-switch>
                </p>
                <div class="box10"></div>
                <p>无专属合同模板的客户，下单购买以上品类商品时，签署此合同</p>
                <div class="box10"></div>
                <div class="t_right">
                  <!--<el-button type="primary" size="small" @click="updateContrat(con)">应用品类</el-button>-->
                  <el-button v-if="conData.editVisiable" type="primary" size="small" @click="updateContrat(con)">合同修改</el-button>
                </div>
              </li>
              <li v-if="con.isDefault == '0'">
                <div class="flex justify_between">
                  <p class="f16 fb"><span class="red">[专属]</span>{{ con.name }}</p>
                  <el-switch v-model="con.isEnable" :active-value="1" :inactive-value="0" @change="edit(con)"></el-switch>
                </div>
                <div class="box10"></div>
                <div class="box110">
                  <p v-if="con.nameMap.goodsNameList && con.nameMap.goodsNameList.split(',').length > 1">
                    <span class="fb">应用商品：</span>
                    {{ con.nameMap.goodsNameList.split(",")[0] }}{{ "、" + con.nameMap.goodsNameList.split(",")[1].substring(0, 4) + "..." }}等
                    {{ con.nameMap.goodsNameList.split(",").length }}个商品
                  </p>
                  <p v-else-if="con.nameMap.goodsNameList && con.nameMap.goodsNameList.split(',').length > 0">
                    <span class="fb">应用商品：</span>
                    {{ con.nameMap.goodsNameList.split(",")[0] + "..." }}等 {{ con.nameMap.goodsNameList.split(",").length }}个商品
                  </p>
                  <p v-else><span class="fb">应用商品：</span> 暂无</p>
                  <p v-if="con.nameMap.customerNameList && con.nameMap.customerNameList.split(',').length > 1">
                    <span class="fb">应用客户：</span>
                    {{ con.nameMap.customerNameList.split(",")[0] }}{{ "、" + con.nameMap.customerNameList.split(",")[1].substring(0, 16) + "..." }}等
                    {{ con.nameMap.customerNameList.split(",").length }}个客户
                  </p>
                  <p v-else-if="con.nameMap.customerNameList && con.nameMap.customerNameList.split(',').length > 0">
                    <span class="fb">应用客户：</span>
                    {{ con.nameMap.customerNameList.split(",")[0] + "..." }}等 {{ con.nameMap.customerNameList.split(",").length }}个客户
                  </p>
                  <p v-else><span class="fb">应用客户：</span> 暂无</p>
                  <p>
                    <span class="fb">自动签署：</span>
                    <el-switch v-model="con.isAutoSign" :active-value="1" :inactive-value="0" @change="editAutoSign(con)"></el-switch>
                  </p>
                  <div class="box10"></div>
                  <p>{{ con.lastUpdateTimeStr }} {{ con.updataName }} 操作。</p>
                </div>
                <div class="box30"></div>
                <div class="t_right" v-if="con.isDefault == '0'">
                  <el-button type="primary" size="small" @click="openGoodsPop(con)">应用商品</el-button>
                  <el-button type="primary" size="small" v-if="con.templateMode != 'VIP_CONTRACT'" @click="openCustomerPop(con)">应用客户</el-button>
                  <el-button type="primary" size="small" @click="updateContrat(con)">合同修改</el-button>
                  <el-button type="primary" size="small" @click="delContrat(con)">删除</el-button>
                </div>
              </li>
            </div>
            <li class="contract_add flex align_center justify_center" v-if="conData.editVisiable" @click="addContrat(conData.templateModeCode)">
              <i class="el-icon-plus"></i>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="con-box50"></div>
    <!--选择客户弹框-->
    <el-dialog
      title="选择客户"
      :visible.sync="customerPop.chooseClientVisible"
      :close-on-click-modal="false"
      width="800px"
      :show-close="false"
      custom-class="chooseClientPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户名称" v-model="customerPop.searchCustomer.name"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listCustomer(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户分组</span>
          <div class="ps_search float-left">
            <el-select v-model="customerPop.searchCustomer.groupId" placeholder="请选择客户分组" clearable>
              <el-option v-for="item in customerPop.groupDataList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear ps_group_list">
          <div class="float-left client_list_all">
            <p>我的客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <!-- 客户-->
                <li v-for="(item, index) in customerPop.customerDataList" :key="index" @click="customerDialogSelect(item)">
                  <div class="client_list_mask" v-if="item.isCheck" v-html="'归属合同模板：' + item.attrName"></div>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <li v-for="(item, index) in conCustomerSel.customerSelList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectCustomer(item)"></i>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box20"></div>
      <el-pagination
        background
        @size-change="handleSizeChangeCustomer"
        @current-change="handleCurrentChangeCustomer"
        :current-page="customerPop.currentPageCustomer"
        :page-sizes="[10, 20, 30]"
        :page-size="customerPop.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="customerPop.totalCount"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="customerDialogConfirm">确 认</el-button>
        <el-button @click="customerDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <!--选择商品弹框-->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsPop.chooseGoodVisible"
      :close-on-click-modal="false"
      width="1140px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">货品名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入货品名称" v-model="goodsPop.searchGoods.name"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listShopGoods(1)">搜索</div>
        </div>
        <div class="clear appoint_goods_list">
          <div class="float-left client_list_all">
            <p>本店货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsPop.goodsDataList" :key="index" @click="goodsDialogSelect(item)">
                  <div class="client_list_mask" v-if="item.isCheck" v-html="'归属合同模板：' + item.attrName"></div>
                  <img class="float-left appoint_good_img" :src="item.picUrl" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis f14">{{ item.name }}</p>
                    <p class="f12">规格：{{ item.spec }}</p>
                    <p class="f12">原价：¥{{ item.marketPriceStr }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsSel.goodsSelList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectGoods(item)"></i>
                  <img class="float-left appoint_good_img" :src="item.picUrl" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis f14">{{ item.name }}</p>
                    <p class="f12">规格：{{ item.spec }}</p>
                    <p class="f12">原价：¥{{ item.marketPriceStr }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box10"></div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="goodsPop.currentGoodsPage"
        :page-sizes="[10, 20, 30]"
        :page-size="goodsPop.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsPop.totalCount"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="goodsDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script type="text/javascript">
// import { mapState } from 'vuex';

export default {
  name: "ContractIndex",

  data() {
    return {
      loading: true,
      conList: [], // 合同列表
      conDataList: [],
      shopId: 0,
      templateMode: "",
      conCustomerSel: {},
      goodsSel: {},
      customerSelected: [],
      goodsSelected: [],

      customerPop: {
        chooseClientVisible: false,
        searchCustomer: {
          name: "",
          phone: "",
          groupId: "",
          pageNum: 1,
          pageSize: 10,
        },
        customerDataList: [],
        customerSelList: [],
        currentPageCustomer: 1,
        groupDataList: [],
        pageSize: 10,
        totalCount: 0,
      },
      goodsPop: {
        chooseGoodVisible: false,
        searchGoods: {
          name: "",
          axis: "",
          pageNum: 1,
          pageSize: 10,
          status: "5",
        },
        goodsDataList: [],
        goodsSelList: [],
        currentGoodsPage: 1,
        groupDataList: [],
        pageSize: 10,
        totalCount: 0,
        options: [],
      },
    };
  },
  created() {
    this.listContract();
  },
  methods: {
    listContract() {
      this.$store.dispatch("shop/shop/getCategoryFirstList").then((data) => {
        this.options = data;
      });
      this.$store.dispatch("contract/contract/listContract", {}).then((data) => {
        const newData = data || {};
        this.conList = newData.attrResList || [];
        const conDataList = Object.values(
          this.conList.reduce((groups, item) => {
            // let templateMode =
            //   item.templateMode === "SHEBEI_CONTRACT"
            //     ? "设备合同"
            //     : item.templateMode == "PT-PTKH" || item.templateMode == "XS-PTKH"
            //     ? "购销合同"
            //     : item.templateMode == "CG-NXKH"
            //     ? "购销合同(农信)"
            //     : item.templateMode == "VIP_CONTRACT"
            //     ? "VIP合同"
            //     : item.templateMode == "TEST_CONTRACT"
            //     ? "测试"
            //     : "普通合同";
            if (!groups[item.templateMode]) {
              groups[item.templateMode] = {
                templateMode: item.templateName,
                templateModeCode: item.templateMode,
                items: [],
              };
            }
            groups[item.templateMode].items.push(item);
            return groups;
          }, {})
        );
        conDataList.forEach((item) => {
          item.editVisiable = true;
          if (item.templateModeCode === "SHEBEI_JG_CONTRACT") {
            item.editVisiable = false;
          }
        });
        console.log("conDataList", conDataList);
        this.conDataList = conDataList;
        this.shopId = newData.shopId;
        this.templateMode = newData.templateMode;
        this.getCustomerGroupList();
      });
    },
    updateContrat(item) {
      /*if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}v/mj/contract/detail?appid=1&isShowTitle=1&templateMode=${item.templateMode}&shopId=${this.shopId}&attrId=${item.attrId}`,
              title: "合同详情",
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}v/mj/contract/detail?templateMode=${item.templateMode}&shopId=${this.shopId}&attrId=${item.attrId}`);
      }*/
      window.location.href = `/v/mj/contract/detail?templateMode=${item.templateMode}&shopId=${this.shopId}&attrId=${item.attrId}`;
    },
    addContrat(templateModeCode) {
      /*if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}v/mj/contract/detail?appid=1&isShowTitle=1&templateMode=${this.templateMode}&shopId=${this.shopId}&attrId=0`,
              title: "合同详情",
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}v/mj/contract/detail?templateMode=${this.templateMode}&shopId=${this.shopId}&attrId=0`);
      }*/
      window.location.href = `/v/mj/contract/detail?templateMode=${templateModeCode}&shopId=${this.shopId}&attrId=0`;
    },
    delContrat(item) {
      this.$confirm("是否删除专属合同?", "提示").then(() => {
        this.$store
          .dispatch("contract/contract/delContract", {
            shopId: this.shopId,
            attrId: item.attrId,
          })
          .then((data) => {
            console.log(data);
            this.listContract();
          });
      });
    },
    edit(item) {
      this.$store
        .dispatch("contract/contract/editContract", {
          shopId: this.shopId,
          attrId: item.attrId,
          isEnable: item.isEnable,
        })
        .then((data) => {
          console.log(data);
        });
    },

    editAutoSign(item) {
      this.$store
        .dispatch("contract/contract/editContract", {
          shopId: this.shopId,
          attrId: item.attrId,
          isAutoSign: item.isAutoSign,
        })
        .then((data) => {
          console.log(data);
        });
    },

    openCustomerPop(item) {
      this.customerPop.currentPageCustomer = 1;
      this.customerPop.chooseClientVisible = true;
      this.$set(item, "customerSelList", item.nameMap.customerSelList || []);
      this.conCustomerSel = item;
      this.$store.dispatch("contract/contract/selContractSelList", { attrId: item.attrId }).then((res) => {
        this.customerSelected = res.customerList || [];
        this.listCustomer(1);
      });
    },
    handleSizeChangeCustomer(val) {
      this.customerPop.pageSize = val;
      this.listCustomer();
    },
    handleCurrentChangeCustomer(val) {
      this.customerPop.currentPageCustomer = val;
      this.listCustomer();
    },
    customerDialogConfirm() {
      this.$store
        .dispatch("contract/contract/saveCustomer", {
          shopId: this.shopId,
          attrId: this.conCustomerSel.attrId,
          customerEntityResList: this.conCustomerSel.customerSelList,
          contractTemplateCode: this.conCustomerSel.templateMode,
        })
        .then((data) => {
          console.log(data);
          this.customerPop.chooseClientVisible = false;
          this.listContract();
        });
    },
    customerDialogClose() {
      this.customerPop.chooseClientVisible = false;
    },
    getCustomerGroupList() {
      const param = { shopId: this.shopId };
      this.$store.dispatch("shop/shop/getCustomerGroupList", this.$qs.stringify(param)).then((data) => {
        this.groupDataList = [];
        if (data) {
          this.customerPop.groupDataList = data;
        }
      });
    },
    listCustomer(type) {
      const { searchCustomer } = this.customerPop;
      searchCustomer.pageNum = this.customerPop.currentPageCustomer;
      searchCustomer.pageSize = this.customerPop.pageSize;
      if (type === 1) {
        // 搜索
        searchCustomer.pageNum = 1;
      }
      this.$store.dispatch("shop/shop/listCustomer", this.$qs.stringify(searchCustomer)).then((data) => {
        const newData = data || {};
        this.customerPop.customerDataList = newData.data || [];
        this.customerPop.totalCount = newData.count || 0;
        if (this.customerPop.customerDataList.length > 0 && this.customerSelected.length > 0) {
          this.customerPop.customerDataList.forEach((item) => {
            this.$set(item, "isCheck", false);
            this.customerSelected.forEach((customer) => {
              if (item.targetIdStr == customer.customerIdStr && this.conCustomerSel.attrId != customer.attrId) {// eslint-disable-line
                item.isCheck = true;
                this.$set(item, "attrName", customer.attrName);
              }
            });
          });
        }
        if (type === 2) {
          if (this.customerPop.customerDataList.length === 0) {
            this.$message.error("无客户数据,请添加客户");
            return;
          }
          this.customerPop.chooseClientVisible = true;
        }
      });
    },
    customerDialogSelect(item) {
      if (item.isCheck) {
        return;
      }
      if (this.conCustomerSel.customerSelList.some((e) => e.id === item.id)) {
        console.log(1);
      } else {
        this.conCustomerSel.customerSelList.push(item);
      }
    },
    removeSelectCustomer(item) {
      this.conCustomerSel.customerSelList.splice(this.conCustomerSel.customerSelList.indexOf(item), 1);
    },

    openGoodsPop(item) {
      this.goodsPop.currentGoodsPage = 1;
      this.goodsPop.chooseGoodVisible = true;
      this.$set(item, "goodsSelList", item.nameMap.goodsSelList || []);
      this.goodsSel = item;
      this.$store.dispatch("contract/contract/selContractSelList", { attrId: item.attrId }).then((res) => {
        this.goodsSelected = res.goodsList || [];
        this.listShopGoods(1);
      });
    },
    handleSizeChange(val) {
      this.goodsPop.pageSize = val;
      this.listShopGoods();
    },
    handleCurrentChange(val) {
      this.goodsPop.currentGoodsPage = val;
      this.listShopGoods();
    },
    goodsDialogConfirm() {
      console.log(this.goodsSel);
      this.$store
        .dispatch("contract/contract/saveGoods", {
          shopId: this.shopId,
          attrId: this.goodsSel.attrId,
          goodsEntityList: this.goodsSel.goodsSelList,
          contractTemplateCode: this.goodsSel.templateMode,
        })
        .then((data) => {
          console.log(data);
          this.goodsPop.chooseGoodVisible = false;
          this.listContract();
        });
    },
    goodsDialogClose() {
      this.goodsPop.chooseGoodVisible = false;
    },
    // 点击添加货品
    selectGoodsList() {
      this.listShopGoods(2);
      this.goodsSelectList = [];
      this.checkGoodsList.forEach((goods) => {
        this.goodsSelectList.push(goods);
      });
    },
    // 查询店铺全部在售非oa商品
    listShopGoods(type) {
      this.goodsPop.searchGoods.pageNum = this.goodsPop.currentGoodsPage;
      this.goodsPop.searchGoods.pageSize = this.goodsPop.pageSize;
      this.$store.dispatch("goods/goods/getShopGoodsList", this.goodsPop.searchGoods).then((data) => {
        if (data && data.goodsList) {
          this.goodsPop.goodsDataList = data.goodsList;
          this.goodsPop.totalCount = data.totalCount;
        }
        if (this.goodsPop.goodsDataList.length > 0 && this.goodsSelected.length > 0) {
          this.goodsPop.goodsDataList.forEach((item) => {
            this.$set(item, "isCheck", false);
            this.goodsSelected.forEach((goods) => {
              if (item.goodsId == goods.goodsId && this.goodsSel.attrId != goods.attrId) {// eslint-disable-line
                item.isCheck = true;
                this.$set(item, "attrName", goods.attrName);
              }
            });
          });
        }
        if (type === 2) {
          if (this.goodsDataList.length === 0) {
            this.$message.error("无货品数据,请添加货品");
            return;
          }
          this.goodsPop.chooseGoodVisible = true;
        }
      });
    },
    // 商品列表页点击商品
    goodsDialogSelect(item) {
      if (item.isCheck) {
        return;
      }
      if (this.goodsSel.goodsSelList.some((e) => e.goodsId === item.goodsId)) {
        console.log(1);
      } else {
        this.goodsSel.goodsSelList.push(item);
      }
    },
    // 删除选择商品弹框中已选择商品
    removeSelectGoods(item) {
      this.goodsSel.goodsSelList.splice(this.goodsSel.goodsSelList.indexOf(item), 1);
    },
  },
};
</script>
